module.exports = __webpack_public_path__ + "img/tuition_layout1.f98a8c9c.png";